var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"home"},[_c('aggregate-statistics'),_c('div',{staticClass:"image-container"}),_c('div',{staticClass:"components"},[_c('public-collections'),_c('characters-list')],1)],1),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }